import {ComponentChild, h} from 'preact'
import Flag from '../ui-components/Flag'

interface Props {
    children: ComponentChild,
    isInstalled: boolean,
    name: string,
    description: string
}

const IntegrationHeader = ({ children, isInstalled, name, description }: Props) => {
  return (
    <div>
      <div class='integrations-card__logo'>
        {children}
      </div>
      <div class='integrations-card__panel-heading-wrapper'>
        <h3 class='integrations-card__panel-heading'>{name} {isInstalled && <Flag text='Installed' success />}</h3>
        <p class='integrations-card__panel-subheading'>{description}</p>
      </div>
    </div>
  )
}

export default IntegrationHeader
